import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Log API URL for debugging (remove in production if needed)
if (process.env.NODE_ENV === 'development' || !process.env.REACT_APP_API_URL) {
  console.log('API URL:', API_URL);
  if (!process.env.REACT_APP_API_URL) {
    console.warn('REACT_APP_API_URL is not set. Using default:', API_URL);
    console.warn('Set REACT_APP_API_URL in Vercel environment variables and redeploy.');
  }
}

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Don't set Content-Type for FormData - let browser set it with boundary
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = String(error.config?.url || '');
      const isExpectedAuthFailure =
        path.includes('auth/login') ||
        path.includes('auth/check-login-email') ||
        path.includes('auth/google');
      if (!isExpectedAuthFailure) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

